import { Center, Spinner, VStack } from '@chakra-ui/react'

import { SignupContainer } from '@src/components/sco/Account/SignupContainer'
import { UserLoginForm } from '@src/components/sco/Account/UserLoginForm'
import { UserSignupRegisterForm } from '@src/components/sco/Account/UserSignupRegisterForm'
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar'
import { SIGNUP_PATHS } from '@src/constants/navigation'
import { useActiveContentContext } from '@src/contexts/ActiveContentContext'
import { useCurrentUser } from '@src/hooks/useCurrentUser'
import { useUniversalEffect } from '@src/hooks/useUniversalEffect'
import { useRouter, useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'
import { useCookie } from 'react-use'

export { getServerSideProps } from '@src/lib/server-side-rendering'
export default function () {
  const router = useRouter()
  const searchParams = useSearchParams()
  const { currentUser } = useCurrentUser()
  const [formType, setFormType] = useState<'register' | 'login'>('register')
  const activeContent = useActiveContentContext()
  const [promoCookie] = useCookie('sco_promo')

  useUniversalEffect(() => {
    activeContent.setSiteSection('signup.register')
  })

  useEffect(() => {
    if (currentUser?.isRegistered) {
      router.push(SIGNUP_PATHS.signupRequest)
    }
  }, [currentUser?.isRegistered])

  if (!currentUser || currentUser?.isRegistered) {
    return (
      <Center minHeight={'90vh'} padding={'1em'}>
        <Spinner />
      </Center>
    )
  }

  return (
    <>
      <ScoSiteNavBar />
      <VStack align={'center'} justify={'center'} minHeight={'90vh'} padding={[0, 0, 0, 6, 6]} width={'full'}>
        <SignupContainer>
          {formType == 'login' ? (
            <UserLoginForm
              containerProps={{ bgColor: 'colorPalette.muted' }}
              returnToHref={SIGNUP_PATHS.signupRequest}
              title={'Login'}
              onRegisterClick={() => setFormType('register')}
            />
          ) : (
            <UserSignupRegisterForm
              containerProps={{ bgColor: 'colorPalette.muted' }}
              hubspotFormKey={'scom-accelerator-registration'}
              returnToHref={promoCookie ? SIGNUP_PATHS.plans : SIGNUP_PATHS.signupRequest}
              title={'Create Your Account'}
              onLoginClick={() => setFormType('login')}
            />
          )}
        </SignupContainer>
      </VStack>
    </>
  )
}
